import { render } from "./CourseCardButton.vue?vue&type=template&id=dd004654&ts=true"
import script from "./CourseCardButton.vue?vue&type=script&lang=ts"
export * from "./CourseCardButton.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__